export class HhgGlobalUpdateStructure {
    rateTypeId: number;
    carrierId: number;
    tenderId: string;
    sroMasterId: number;
    sroMasterIds: number;
    controlId: number;
    originId: number;
    destinationId: number;
    linehaulChangeType: string;
    classVehicle1ChangeType: string;
    classVehicle2ChangeType: string;
    classVehicle3ChangeType: string;
    storageInTransitChangeType: string;
    accessorialsChangeType: string;
    unaccompaniedAirBagChangeType: string;
    linehaul: number;
    classVehicle1: number;
    classVehicle2: number;
    classVehicle3: number;
    storageInTransit: number;
    accessorials: number;
    unaccompaniedAirBag: number;
    bookingEmail: string;
    bookingPhone: number;
    transportType?: any;
    ratesBidcyclesId?: any;
    updateType: string;
}

export class HhgGlobalUpdateResponse {
    successCount: number;
    failureCount: number;
}
